export const phoneNumberRegex =
  /^(?:\+?\d{1,4}[ \\-]*)?(?:\(\d{2,4}\)[ \\-]*)?\d{2,4}[ \\-]*\d{3,4}[ \\-]*\d{3,4}$/

// There's a problem with yup .email() validation function which causes
// infinite recursion when " sign is present in the value
// https://github.com/jquense/yup/issues/1303 -> still not resolved
export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\]\\.,;:\s@\\"]+\.)+[^<>()[\]\\.,;:\s@\\"]{2,})$/i
